__turbopack_context__.v({
  "label": "VdwC9W_label",
  "subtitle": "VdwC9W_subtitle",
  "tileContainer": "VdwC9W_tileContainer",
  "tileGroupContainer": "VdwC9W_tileGroupContainer",
  "title": "VdwC9W_title",
});
